export default __webpack_public_path__ + "static/apple-fa70043cc8eb3c6eb509a53a5dbd7e0d.png";